export enum EToastContainerIds {
  stacked = 'stacked',
}

export const EToastTypes = {
  info: 'info',
  success: 'success',
  warning: 'warning',
  error: 'error',
  default: 'info',
} as const;

export type TToastType = (typeof EToastTypes)[keyof typeof EToastTypes];
